import React from 'react';
import useTheme from 'branding/theme';
import withHover from '../../hocs/withHover';
import ChoiceLabel from '../../typography/ChoiceLabel';
import AccessiblyHiddenChoice from '../AccessiblyHiddenChoice';
import CheckboxSquare from '../../graphics/CheckboxSquare';
import { useWatch } from 'react-hook-form';
import { withFormProps } from '../../hocs/withFormProps/withFormProps';
import withFocus from '../../hocs/withFocus';
import mergeFocusHandlers from '../../utils/mergeFocusHandlers';
export const StandaloneCheckbox = React.forwardRef(({ name, labelText, disabled = false, showErrMessage = true, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleBlur, handleFocus, onBlur, className, styles, ...rest }, ref) => {
    const isChecked = useWatch({ name });
    const focusHandlers = mergeFocusHandlers({ handleBlur, handleFocus, onBlur });
    const { colors, inputs: { choiceStyles }, sizing } = useTheme();
    const mergedStyles = {
        ...choiceStyles.base,
        padding: `${sizing.component.padding.small} 0`,
        ...(!disabled &&
            isHovered && {
            ...choiceStyles.hovered,
            backgroundColor: colors.neutrals.background
        }),
        ...styles
    };
    return (React.createElement("div", { className: className, style: mergedStyles },
        React.createElement(AccessiblyHiddenChoice, { type: "checkbox", name: name, disabled: disabled, isHovered: isHovered, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, handleTouchEnd: handleMouseLeave, handleBlur: handleBlur, ref: ref, ...focusHandlers, ...rest }),
        React.createElement(CheckboxSquare, { isChecked: isChecked, isFocused: isFocused, isHovered: isHovered, disabled: disabled }),
        React.createElement(ChoiceLabel, { htmlFor: name, disabled: disabled }, labelText)));
});
export default withFocus(withHover(withFormProps(StandaloneCheckbox)));
//# sourceMappingURL=index.js.map